<template>
    <div class="form__container" :id="'input_' + inputData.id">
        <label :for="'inputField_' + inputData.id" class="form__heading">
            <span>{{ inputData.name }}</span>
            <required-indicator :inputData="inputData"></required-indicator>
        </label>
        <p class="form__description" :id="'description_' + inputData.id" v-if="inputData.desc">{{ inputData.desc }}</p>

        <div class="form__input-container--select">
            <select class="form__input--select"
                :aria-describedby="(inputData.desc ? ('description_' + inputData.id) : '') + (inputData.error ? (' error_' + inputData.id) : '')"
                :class="inputData.error ? 'form__input--error' : ''"
                :id="'inputField_' + inputData.id"
                :name="inputData.id"
                v-model="inputValue"
                @change="updateSelectedCountry">
                <option value="">{{ $t('chooseCountry')}}</option>
                <option v-for="inputOption in countries"
                    :value="inputOption.id"
                    :key="inputOption.id"
                    :selected="inputOption.id === inputValue"
                    >{{ inputOption['name_' + this.$i18n.locale] }}</option>
            </select>
        </div>
        <div class="form__error" :id="'error_' + inputData.id" v-if="inputData.error" role="alert">{{ inputData.error }}</div>
        <div>
            <span class="form__explanation" v-if="inputData.explanation">{{ inputData.explanation }}</span>
        </div>
        
    </div>
</template>

<script>
import axios from 'axios';
import { ref, onMounted, watch, computed} from 'vue';
import { useI18n } from 'vue-i18n'
import RequiredIndicator from './RequiredIndicator.vue';

const DEFAULT_COUNTRY_CODE = '';

export default {
    props: ['inputData'],
    emits: ['inputValue'],
    components: {
        'required-indicator': RequiredIndicator
    },
    setup(props, ctx){
        const inputValue = ref(DEFAULT_COUNTRY_CODE);
        const isNorwegianCitizen = ref(true);
        const countries = ref([]);

        const { t, locale } = useI18n();

        function updateNorwegianCitizen(){
            inputValue.value = DEFAULT_COUNTRY_CODE;
            ctx.emit('inputValue', props.inputData.id, inputValue.value);
        }


        function updateSelectedCountry(event){
            ctx.emit('inputValue', props.inputData.id, inputValue.value);
        }

        onMounted(() => {
            ctx.emit('inputValue', props.inputData.id, inputValue.value);
            axios.get('/xhr/v1/frontend/country')
                .then(response => {
                    countries.value = response.data;
                    countries.value.sort((a, b) => a['name_' + locale.value].localeCompare(b['name_' + locale.value], locale.value));
                })
                .catch(error => {
                    console.log(error);
                });
        });

        watch(props, (oldValue, newValue) => {
            if (newValue.inputData.value) {
                isNorwegianCitizen.value = newValue.inputData.value == DEFAULT_COUNTRY_CODE;
                inputValue.value = newValue.inputData.value;
                ctx.emit('inputValue', props.inputData.id, inputValue.value);
            }
        });

        return {
            inputValue,
            isNorwegianCitizen,
            countries,
            updateNorwegianCitizen,
            updateSelectedCountry
        }
    }
}
</script>